var pdp_salsify = {
  datalayer: {
    init: function() {
      var el = $('.product-container');
      if (el.length == 0) return;

      var idx = 1
      $('[data-section]', el).each(function(i) {
        var _t = $(this);
        var section = _t.attr('data-section') || '';
        var is_skip = _t.attr('data-section-skip') || 'false';
        if (section != '' && is_skip == 'false') {
          _t.parent().attr('data-section', section)
            .attr('data-position', idx);
          
          _t.removeAttr('data-section');
          idx++;
        }
      });
      $('[data-module]', el).each(function(i) {
        var _t = $(this);
        var node = $(this).get(0).nodeName;
        var module = _t.attr('data-module') || '';
        if (module != '' && node != 'SECTION') {
          _t.parent().attr('data-module', module);
          
          _t.removeAttr('data-module');
        }
      });

      // info_page_link
      // collection_link
      $('a', el).each(function() {
        var _t = $(this);
        var href = _t.attr('href') || '';

        var url_obj = new URL(href, window.location.origin);
        if (url_obj.origin != window.location.origin) return true;

        var data_track_id = pdp_salsify.datalayer.getDataTrackId(href);
        if (data_track_id != '') {
          _t.attr('data-track-id', data_track_id);
        }
      });

      // upsell
      var upsell_el = $('.product-upsells', el);
      if (upsell_el.length == 1) {
        var item_lists = [];
        $('.product-upsell', upsell_el).each(function() {
          var _t = $(this);
          var item_list = _t.attr('data-datalayer') || '';
          if (item_list != '') {
            item_lists.push(item_list);
          }
        });

        if (item_lists.length > 0) {
          upsell_el.parents('[data-module="Pair it with"]')
            .attr('data-item-list', `[${item_lists.join(',')}]`)
            .attr('data-track-view', 'true');
        }
      }

      // related
      var related_el = $('.related-products', el);
      if (related_el.length == 1) {
        var item_lists = [];
        $('.product-card-container', related_el).each(function() {
          var _t = $(this);
          var item_list = _t.attr('data-datalayer') || '';
          if (item_list != '') {
            item_lists.push(item_list);
          }
        });

        if (item_lists.length > 0) {
          related_el.parents('[data-section="Related Products"]')
            .attr('data-item-list', `[${item_lists.join(',')}]`)
            .attr('data-track-view', 'true');
        }
      }

      // accordion
      $('.pdp-block-accordion-box:empty').remove();
    },
    getDataTrackId: function(href) {
      var data_track_id = '';

      if (window.kef.datalayer.campaign_page_urls.indexOf(href) >= 0) {
        data_track_id = 'campaign_link';
      } else if (window.kef.datalayer.campaign_product_page_urls.indexOf(href) >= 0) {
        data_track_id = 'campain_product_link';
      } else if (href.indexOf('/pages/book-a-demo') >= 0) {
        data_track_id = 'book_demo';
      } else if (href.indexOf('/pages/') >= 0) {
        data_track_id = 'info_page_link';
      } else if (href.indexOf('/collections/') >= 0) {
        data_track_id = 'collection_link';
      } else if (href.indexOf('/products/') >= 0) {
        data_track_id = 'select_item';
      } else if (href.indexOf('/blogs/') >= 0) {
        data_track_id = 'select_blog';
      }

      return data_track_id;
    },
  },
  video_worker: {
    init: function() {
      var el = $('.video-player-box');
      if (el.length == 0) return;
      if (typeof VideoWorker === 'undefined') {
        // init video-worker
        var script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/video-worker@2/dist/video-worker.min.js';
        script.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script);
  
        script.onload = function() {
          var script2 = document.createElement('script');
          script2.src = window.kef.assets.video_worker.js;
          script2.type = 'text/javascript';
          document.getElementsByTagName('head')[0].appendChild(script2);
  
          script2.onload = function() {
            pdp_salsify.video_worker.initFn();
          }
        }
      } else if (typeof video_player === 'undefined') {
        var script2 = document.createElement('script');
        script2.src = window.kef.assets.video_worker.js;
        script2.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(script2);

        script2.onload = function() {
          pdp_salsify.video_worker.initFn();
        }
      } else {
        pdp_salsify.video_worker.initFn();
      }
    },
    initFn: function() {
      // video_player.initOffline();
      video_player.init();

      $('.video-player-box .btn-play').on('click', function(e) {
        var vid = $(this);
        video_player.stopAll();
        video_player.play(vid);
        e.preventDefault();
      });
      $('.video-player-box .video-player').on('click', function(e) {
        var vid = $(this);
        // if (vid.parent('.video-player-box').hasClass('paused')) {
        //   video_player.play(vid);
        // } else if (vid.parent('.video-player-box').hasClass('playing')) {
        //   video_player.pause(vid);
        // }
        if (vid.parent('.video-player-box').hasClass('playing')) {
          video_player.pause(vid);
        }
        e.preventDefault();
      });
    },
  },
  hero_video: {
    init: function() {
      var el = $('.pdp-block-hero-video');
      if (el.length == 0) return;

      var video_url = $('.video-player-box .video-player', el).attr('data-url') || '';
      if (video_url.indexOf('youtube') !== -1) {
        var video_url_obj = new URL(video_url),
            video_bg = `https://i.ytimg.com/vi_webp/${video_url_obj.searchParams.get('v')}/maxresdefault.webp`;
        $('.video-player-bg', el).html(`<img src="${video_bg}" alt="" loading="lazy">`);
      }
    },
  },
  hero_feature: {
    init: function() {
      var el = $('.pdp-block-hero-feature');
      if (el.length == 0) return;

      var img_url = $('img', el).attr('src') || '',
          content_el = $('.pdp-block-hero-feature-content', el);
          
      wcag.colorContrast.getByBackground(img_url, content_el.width(), content_el.height(), function(text_color) {
        var class_name = text_color == '#fff' ? 'dark-theme' : 'light-theme';
        el.removeClass('dark-theme light-theme').addClass(class_name)
          .css('--feature-card-text-color', text_color);
      });
    },
  },
  accordion_specs: {
    init: function() {
      var el = $('.pdp-block-accordion-specs');
      if (el.length == 0) return;

      $('.product-salsify-sticky-menu').on('click', 'a[href="#specifications"]', function(e) {
        $('#accordion-details-specs').prop('checked', true).trigger('change');
      });

      // combine specifications
      $('.pdp-block-accordion-spec-item[data-spec-combine]', el).each(function() {
        var _t = $(this),
            spec_key = _t.attr('data-spec-key') || '',
            spec_combine_flag = _t.attr('data-spec-combine') || 'false',
            spec_combine_flag = spec_combine_flag == 'true' ? true : false;

        if (spec_key == '') return;

        var spec_values = [],
            first_metric_keys = ['mm', 'kg'],
            metric_keys = ['mm', 'in', 'inches', 'kg', 'lb']
            gross_weight_keys = ['gross-weight', 'gross-wight'];
        $(`.pdp-block-accordion-spec-item[data-spec-key*="${spec_key}"]:not([data-spec-combine])`, el).each(function() {
          var _t1 = $(this),
              spec_key1 = _t1.attr('data-spec-key') || '';
              spec_value1 =  $('.pdp-block-accordion-spec-item-value', _t1).html() || '',
              
              idx_metric_key = metric_keys.findIndex(key => spec_key1.indexOf(key) >= 0),
              has_metric_value = metric_keys.some(key => spec_value1.indexOf(key) >= 0),

              idx_first_metric_key = first_metric_keys.findIndex(key => spec_value1.indexOf(key) >= 0),
              has_first_metric_value = first_metric_keys.some(key => spec_value1.indexOf(key) >= 0),

              has_weight_key = gross_weight_keys.some(key => spec_key1.indexOf(key) >= 0);

          if (spec_value1 != '') {
            if (spec_values.length == 0) {
              spec_values = setComboSpecValueFirst(spec_values, spec_value1, {
                spec_key: spec_key,
                spec_combine_flag: spec_combine_flag,
                has_weight_key: has_weight_key,
                has_first_metric_value: has_first_metric_value,
                idx_first_metric_key: idx_first_metric_key,
                has_metric_value: has_metric_value,
                idx_metric_key: idx_metric_key,
              });
            } else {
              spec_values = setComboSpecValueNext(spec_values, spec_value1, {
                spec_key: spec_key,
                spec_combine_flag: spec_combine_flag,
                has_weight_key: has_weight_key,
                has_first_metric_value: has_first_metric_value,
                idx_first_metric_key: idx_first_metric_key,
                has_metric_value: has_metric_value,
                idx_metric_key: idx_metric_key,
              });
            }
          }

          // _t1.remove();
        });
        function setComboSpecValueFirst(spec_values, spec_value, conditions = {}) {
          var { spec_key, spec_combine_flag, has_weight_key, has_first_metric_value, idx_first_metric_key, has_metric_value, idx_metric_key } = conditions;
          // console.log('first', spec_key, spec_value, spec_combine_flag, has_weight_key, has_first_metric_value, idx_first_metric_key, has_metric_value, idx_metric_key);

          if (has_weight_key) {
            spec_values = setComboGrossWeightSpecValueFirst(spec_values, spec_value, conditions);

          } else if (has_first_metric_value || has_metric_value) {
            spec_values.push(spec_value);

          } else if (idx_first_metric_key >= 0) {
            spec_values.push(`${spec_value}${first_metric_keys[idx_first_metric_key]}`);

          } else {
            spec_values.push(`${spec_value}${metric_keys[idx_metric_key] || ''}`);

          }

          return spec_values;
        }
        function setComboSpecValueNext(spec_values, spec_value, conditions = {}) {
          var { spec_key, spec_combine_flag, has_weight_key, has_first_metric_value, idx_first_metric_key, has_metric_value, idx_metric_key } = conditions;
          // console.log('next', spec_key, spec_value, spec_combine_flag, has_weight_key, has_first_metric_value, idx_first_metric_key, has_metric_value, idx_metric_key);

          if (has_weight_key) {
            spec_values = setComboGrossWeightSpecValueNext(spec_values, spec_value, conditions);

          } else if (! spec_combine_flag) {
            if (has_first_metric_value) {
              spec_values[0] = spec_value;
  
            } else if (idx_first_metric_key >= 0) {
              spec_values[0] = `${spec_value} ${first_metric_keys[idx_first_metric_key]}`;
  
            } else if (has_metric_value) {
              // spec_values.push(`(${spec_value})`);
  
            } else {
              // spec_values.push(`(${spec_value}${metric_keys[idx_metric_key] || ''})`);
  
            }

          } else if (has_first_metric_value) {
            spec_values[0] = `(${spec_values[0]})`
            spec_values.unshift(spec_value);

          } else if (idx_first_metric_key >= 0) {
            spec_values[0] = `(${spec_values[0]})`
            spec_values.unshift(`${spec_value}${first_metric_keys[idx_first_metric_key]}`);

          } else if (has_metric_value) {
            spec_values.push(`(${spec_value})`);

          } else {
            spec_values.push(`(${spec_value}${metric_keys[idx_metric_key] || ''})`);

          }

          return spec_values;
        }
        function setComboGrossWeightSpecValueFirst(spec_values, spec_value, conditions = {}) {
          var { spec_key, spec_combine_flag, has_weight_key, has_first_metric_value, idx_first_metric_key, has_metric_value, idx_metric_key } = conditions;

          spec_values = spec_value.split('<br>');

          spec_values.forEach(function(item, index) {
            if (has_first_metric_value || has_metric_value) {
              spec_values[index] = item;
  
            } else if (idx_first_metric_key >= 0) {
              spec_values[index] = item[idx_first_metric_key];
  
            } else {
              spec_values[index] = item + (metric_keys[idx_metric_key] || '');
  
            }
          });

          return spec_values;
        }
        function setComboGrossWeightSpecValueNext(spec_values, spec_value, conditions = {}) {
          var { spec_key, spec_combine_flag, has_weight_key, has_first_metric_value, idx_first_metric_key, has_metric_value, idx_metric_key } = conditions;

          var texts = window.kef.salsify.texts.gross_weight;

          if (spec_values.length > 1) {
            spec_value.split('<br>').forEach(function(item, index) {
              if (has_first_metric_value) {
                spec_values[index] = `${item} (${spec_values[index]})`;
    
              } else if (idx_first_metric_key >= 0) {
                spec_values[index] = `${item}${first_metric_keys[idx_first_metric_key]} (${spec_values[index]})`;
    
              } else if (has_metric_value) {
                spec_values[index] = `${item} (${spec_values[index]})`;

              } else {
                spec_values[index] = `${spec_values[index]} (${item}${metric_keys[idx_metric_key] || ''})`;
    
              }
              spec_values[index] = (index == 0 ? texts['single_box'] : texts['master_box']) + ' ' + spec_values[index] + (index == 0 ? '<br>' : '');
            });
          } else {
            if (has_first_metric_value) {
              spec_values[0] = `(${spec_values[0]})`
              spec_values.unshift(spec_value);
  
            } else if (idx_first_metric_key >= 0) {
              spec_values[0] = `(${spec_values[0]})`
              spec_values.unshift(`${spec_value}${first_metric_keys[idx_first_metric_key]}`);
  
            } else {
              spec_values.push(`(${spec_value}${metric_keys[idx_metric_key] || ''})`);
  
            }
          }

          return spec_values;
        }
        // combine specifications

        if (spec_values.length > 0) {
          _t.find('.pdp-block-accordion-spec-item-value').html(spec_values.join(' '));
        }
      });

      // // special specifications
      // var net_weight_remarks_el = $('.pdp-block-accordion-spec-item[data-spec-key="specifications-net-weight-remarks"]', el);
      // if (net_weight_remarks_el.length > 0) {
      //   var net_weight_remarks_value = $('.pdp-block-accordion-spec-item-value', net_weight_remarks_el).text();
      //   $('.pdp-block-accordion-spec-item[data-spec-key="specifications-weight"] .pdp-block-accordion-spec-item-header', el).append(' ' + net_weight_remarks_value);
      // }
    },
  },
  accordion_awards: {
    init: function() {
      var el = $('.pdp-block-accordion-awards');
      if (el.length == 0) return;

      $('.product-salsify-sticky-menu').on('click', 'a[href="#awards"]', function(e) {
        $('#accordion-details-awards').prop('checked', true).trigger('change');
      });
    },
  },
  accordion_downloads: {
    init: function() {
      var el = $('.pdp-block-accordion-downloads');
      if (el.length == 0) return;

      $('.product-container').on('click', 'a[href="#download-documents"]', function(e) {
        $('#accordion-details-downloads').prop('checked', true).trigger('change');

        if ($(this).parents('.product-salsify-sticky-menu').length == 1) return;

        $('.product-salsify-sticky-menu a[href="#download-documents"]').trigger('click');
        // document.querySelector('.product-salsify-sticky-menu a[href="#download-documents"]').click();

        e.preventDefault();
      });
    },
  },
  accordion_videos: {
    init: function() {
      var el = $('.pdp-block-accordion-videos');
      if (el.length == 0) return;

      $('.video-player-box .video-player', el).each(function() {
        var video_url = $(this).attr('data-url') || '';
        if (video_url.indexOf('youtube') !== -1) {
          var video_url_obj = new URL(video_url),
              video_bg = `https://i.ytimg.com/vi_webp/${video_url_obj.searchParams.get('v')}/hqdefault.webp`,
              video_title = $(this).parents('.pdp-block-accordion-video').find('h3').text() || '';
          $(this).next('.video-player-bg').html(`<img src="${video_bg}" alt="${video_title}" loading="lazy">`);
        }
      });
    },
  },
  feature_cards: {
    init: function() {
      var el = $('.pdp-block-feature-cards');
      if (el.length == 0) return;

      var slider_classname = '.pdp-block-feature-cards';
      new Swiper(`${slider_classname} .swiper`, {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 20,
        slidesPerView: 'auto',
        freeMode: true,
        centerInsufficientSlides: true,
        focusableElements: 'h3,div',
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
          hide: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          481: {
            spaceBetween: 20,
          },
        },
        on: {
          afterInit: function(swiper) {
            // color contrast
            $(window).on('load', function() {
              $('.pdp-block-feature-card-item', el).each(function() {
                var _t = $(this);
                var img_el = $('.pdp-block-feature-card-item-media img', _t),
                    // img_url = $('.pdp-block-feature-card-item-media img', _t).attr('src') || '',
                    content_el = $('.pdp-block-feature-card-item-content-inner', _t);
                    
                wcag.colorContrast.getByBackground(img_el, content_el.width(), content_el.height(), function(text_color) {
                  var class_name = text_color == '#fff' ? 'dark-theme' : 'light-theme';
                  _t.removeClass('dark-theme light-theme').addClass(class_name)
                    .css('--feature-card-text-color', text_color);
                });
              });
            });
          },
        },
      });
    },
  },
  tab_slider: {
    init: function() {
      var el = $('.pdp-block-tab-slider');
      if (el.length == 0) return;

      var style = document.createElement('link');
      style.href = window.kef.assets.swiper.css;
      style.rel = 'stylesheet';
      document.getElementsByTagName('head')[0].appendChild(style);

      var script = document.createElement('script');
      script.src = window.kef.assets.swiper.js;
      script.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(script);
    },
  },

  // v2 2025
  key_features: {
    init: function() {
      var el = $('.pdp-block-key-features');
      if (el.length == 0) return;

      var slider_classname = '.pdp-block-key-features';
      new Swiper(`${slider_classname} .swiper`, {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        centerInsufficientSlides: true,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          481: {
            spaceBetween: 20,
          },
        },
      });
    },
  },
  connectivity_blocks: {
    init: function() {
      var el = $('.pdp-block-connectivity-blocks');
      if (el.length == 0) return;

      var slider_classname = '.pdp-block-connectivity-blocks';
      new Swiper(`${slider_classname} .swiper`, {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 16,
        slidesPerView: 'auto',
        freeMode: true,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
          hide: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 0,
            slidesPerView: 4,
            grid: {
              fill: 'row',
              rows: 2,
            },
          },
          850: {
            spaceBetween: 0,
            slidesPerView: 6,
            grid: {
              fill: 'row',
              rows: 2,
            },
          },
          1200: {
            spaceBetween: 0,
            slidesPerView: 8,
            grid: {
              fill: 'row',
              rows: 2,
            },
          },
        },
      });
    },
  },
  feature_a: {
    init: function() {
      var el = $('.pdp-block-feature-a-blocks');
      if (el.length == 0) return;

      var slider_classname = '.pdp-block-feature-a-blocks';
      new Swiper(`${slider_classname} .swiper`, {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 16,
        slidesPerView: 'auto',
        freeMode: true,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
          hide: true,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 0,
            slidesPerView: 3,
            grid: {
              fill: 'row',
              rows: 2,
            },
          },
        },
      });
    },
  },
};
$(function() {
  pdp_salsify.datalayer.init();
  pdp_salsify.video_worker.init();

  pdp_salsify.hero_video.init();
  pdp_salsify.hero_feature.init();
  pdp_salsify.accordion_specs.init();
  pdp_salsify.accordion_awards.init();
  pdp_salsify.accordion_downloads.init();
  pdp_salsify.accordion_videos.init();
  pdp_salsify.feature_cards.init();
  pdp_salsify.tab_slider.init();

  // v2 2025
  pdp_salsify.key_features.init();
  pdp_salsify.connectivity_blocks.init();
  pdp_salsify.feature_a.init();
});